import ufeApi from 'services/api/ufeApi';

function addPickupDetails({ firstName, lastName, email }) {
    const url = '/api/checkout/orders/shippingGroups/pickupDetails';

    const payload = {
        firstName,
        lastName,
        email,
        shippingGroupId: '0'
    };

    const headers = {
        'Content-Type': 'application/json',
        'x-requested-source': 'web'
    };

    return ufeApi
        .makeRequest(url, {
            method: 'POST',
            headers,
            body: JSON.stringify(payload)
        })
        .then(data => (data.errorCode ? Promise.reject(data) : data));
}

export default addPickupDetails;
